export default "__VITE_ASSET__BSxTINrK__"